import { createAction, props } from '@ngrx/store';
import { Category } from '../../models/category';
import { CategoryPagination } from '@modules/category/models/category-pagination';
import { CategoryFilter } from '@modules/category/models/category-filter';

export const AddCategories = createAction('ADD CATEGORIES', props<{ categories: Category[] }>());

export const AddCategory = createAction('ADD CATEGORY', props<{ category: Category }>());

export const AddError = createAction('ADD CATEGORY ERROR', props<{ error: any }>());

export const AddTotalCount = createAction('ADD CATEGORY TOTAL COUNT', props<{ totalCount: number }>());

// Effecs actions

export const FetchCategories = createAction('[Api] FETCH CATEGORIES', props<{categoryPagination: CategoryPagination, categoryFilter: CategoryFilter}>());

export const GetCategory = createAction('[Api] GET CATEGORY', props<{ id: string }>());
